module.exports = __webpack_public_path__ + "img/6_114.04568602.png";